export default "__VITE_ASSET__BT8N5Vw4__"